import { useEffect } from 'react';
import { canHaveTestClientReset, fetchTestClientResetState } from '../services/TestClientResetService';
import { isResetRunning, useTestClientResetStore } from '../store/useTestClientResetStore';

export const TEST_CLIENT_RESET_POLL_MS = 10000;

// Busca o estado do reset ao montar e, enquanto houver reset na fila ou rodando, de novo a cada 10 s.
export const useTestClientResetMonitor = (login?: string) => {
  const isEligible = canHaveTestClientReset(login);
  const isRunning = useTestClientResetStore(state => isResetRunning(state.resetState?.lastReset));
  const applyResetState = useTestClientResetStore(state => state.applyResetState);
  const resetTestClientResetStore = useTestClientResetStore(state => state.resetTestClientResetStore);

  useEffect(() => {
    if (!isEligible) return undefined;
    fetchTestClientResetState()
      .then(applyResetState)
      .catch(() => applyResetState(null));
    return resetTestClientResetStore;
  }, [isEligible, applyResetState, resetTestClientResetStore]);

  useEffect(() => {
    if (!isEligible || !isRunning) return undefined;
    const timer = setInterval(() => {
      fetchTestClientResetState()
        .then(applyResetState)
        .catch(() => undefined);
    }, TEST_CLIENT_RESET_POLL_MS);
    return () => clearInterval(timer);
  }, [isEligible, isRunning, applyResetState]);
};
